import {Col, Divider, InputNumber, Row, Slider} from 'antd';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {updateMovementStepSize} from "../../redux_actions/livemode.action";

class LiveModeGeneralSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coarseFocusZLevel: 1500,
        }
    }

    stepSizeChange = (value) => {
        this.props.dispatch(updateMovementStepSize(value));
    }

    getCameraSliderRow = (haveRowStyle, heading, slider, inputBox) => {
        return (
            <Row style={haveRowStyle ? {marginTop: 5} : {}}>
                <Col offset={1} span={7}>
                    <b>{heading}</b>
                </Col>
                <Col offset={1} span={9}>
                    {slider}
                </Col>
                <Col offset={1} span={4}>
                    {inputBox}
                </Col>
            </Row>
        )
    }

    render() {

        let image = document.getElementById('liveCameraImage');

        let maxXYVal = 0.75;

        if (image != null) {
            // maxXYVal = Math.min((image.width * 0.0000825 * 2.5).toFixed(1), (image.height * 0.0000825 * 2.5).toFixed(1));
            maxXYVal = Math.min((image.width * 0.0003 * 2.5).toFixed(1), (image.height * 0.0003 * 2.5).toFixed(1));
        }

        return (
            <Row>
                <Col span={24}>
                    <Row>
                        <Col span={24} className="settings-heading">
                            <b>General Settings</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col offset={1} span={22} className="custom-top-bottom-margin-divider">
                            <Divider/>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className="settings-subheading">
                            <b>This is for keyboard motion</b>
                        </Col>
                    </Row>
                    {this.getCameraSliderRow(true, 'Step Size (mm.)',
                        <Slider value={this.props.livemode.movementStepSize} min={0.01} max={maxXYVal} step={0.01}
                                tooltipVisible={false}
                                onChange={this.stepSizeChange} style={{padding: 0, margin: '8px 0px 0px 0px'}}
                                disabled={this.props.adminState.live_mode_action || !this.props.livemode.accessToLiveMode || this.props.livemode.useLiveModeInViewMode} /*onFocus={this.onFocusInputField} onBlur={this.onBlurInputField}*/ />,
                        <InputNumber style={{width: '100%'}} className="card-color" size="small"
                                     value={this.props.livemode.movementStepSize} disabled={true}/>
                    )}
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        liveView: state.liveViewReducer,
        adminState: state.adminUrlReducer,
        livemode: state.livemodeReducer,
    };
};

export default connect(mapStateToProps)(LiveModeGeneralSettings);
